export default "__VITE_PUBLIC_ASSET__8455ed13__"